import { DocumentNode, gql } from "@apollo/client";

export default class OrderService {
  public static getOrder = (): DocumentNode => gql`
    query GetOrder($orderUidPublic: String!) {
      getOrder(orderUidPublic: $orderUidPublic) {
        orderUidPublic
        items {
          uid
          testType
          panels {
            name
            microdelPanel
          }
          product {
            configuration {
              sampleCollectionManagedBy
              caPnsSupplemental
            }
          }
        }
        clinic {
          limsId
          name
          settings {
            testSettings {
              ... on ClinicTestSetting {
                testType
                nevaEnabled
              }
            }
          }
          address {
            state
          }
        }
        workflows {
          uid
          type
          simpleOrderState
          sampleType
        }
      }
    }
  `;
}
